import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

interface NavigationState {
  destinationPath: string | null;
  activeTab?: {
    tabFieldName: string;
    tabFieldValue: any;
  } | null;
}

const initialState: NavigationState = {
  destinationPath: null,
};

const NavigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setDestinationPath: (state, action: PayloadAction<string>) => {
      state.destinationPath = action.payload; // Set the destination path
    },
    clearDestinationPath: (state) => {
      state.destinationPath = null; // Clear the destination path
    },
    setActiveTab: (
      state,
      action: PayloadAction<{ tabFieldName: string; tabFieldValue: any }>
    ) => {
      state.activeTab = action.payload;
    },
    clearActiveTab: (state) => {
      state.activeTab = null; // Clear the activeTab value
    },
  },
});

export const { setDestinationPath, clearDestinationPath, setActiveTab, clearActiveTab } = NavigationSlice.actions;

export const selectNavigation = (state: RootState) => state.navigation;

export default NavigationSlice.reducer;
